export let privacyChoicesLink = "IdSjSb";
export default {privacyChoicesLink};